import SlideAnimator from './slide-animator';


class IndexesSlideAnimator extends SlideAnimator {

	constructor({positionVar = '--slidePosition', balancedPositionVar = '--slideBalancedPosition', animateClass = 'animate'} = {}) {
		super();
		this.positionVar = positionVar;
		this.balancedPositionVar = balancedPositionVar;
		this.animateClass = animateClass;
	}


	setup(slideshow) {
		this.slideshow = slideshow;
		this.isCircular = slideshow.isCircular();
		this.slidesCount = slideshow.getSlidesCount();
		this.slidesElements = slideshow.getSlides().map((slide) => slide.getElement());
	}


	switch(currentSlide, newSlide, direction) {
		const currentSlideElement = currentSlide.getElement();
		const newSlideElement = newSlide.getElement();
		const offset = newSlideElement.style.getPropertyValue(this.positionVar) - currentSlideElement.style.getPropertyValue(this.positionVar);
		const balancedOffset = newSlideElement.style.getPropertyValue(this.balancedPositionVar) - currentSlideElement.style.getPropertyValue(this.balancedPositionVar);
		// direction = offset > 0 ? 1 : -1;
		const balancedDirection = balancedOffset > 0 ? 1 : -1;

		const slideshowElement = this.slideshow.getElement();
		this.classList(slideshowElement).add(this.animateClass);

		const balancedUpperLimit = Math.floor(this.slidesCount / 2);
		const balancedLowerLimit = -Math.floor((this.slidesCount - 1) / 2);
		const positionReMap = [];
		const balancedPositionReMap = [];

		for (const slideElement of this.slidesElements) {
			const currentPosition = slideElement.style.getPropertyValue(this.positionVar);
			const currentBalancedPosition = slideElement.style.getPropertyValue(this.balancedPositionVar);
			const newPosition = currentPosition - offset;
			const newBalancedPosition = currentBalancedPosition - balancedOffset;
			slideElement.style.setProperty(this.positionVar, newPosition);
			slideElement.style.setProperty(this.balancedPositionVar, newBalancedPosition);
			if (this.isCircular) {
				if (newPosition >= this.slidesCount || newPosition < 0) {
					positionReMap.push({element: slideElement, nextValue: (newPosition + this.slidesCount) % this.slidesCount});
				}
				if (newBalancedPosition > balancedUpperLimit || newBalancedPosition < balancedLowerLimit) {
					balancedPositionReMap.push({element: slideElement, nextValue: balancedDirection * this.slidesCount + newBalancedPosition});
				}
			}
		}

		return this.onTransitionEnd(newSlideElement).then(() => {
			newSlideElement.focus({preventScroll: true});
			this.classList(slideshowElement).remove(this.animateClass);
			if (this.isCircular) {
				for (const item of positionReMap) {
					item.element.style.setProperty(this.positionVar, item.nextValue);
				}
				for (const item of balancedPositionReMap) {
					item.element.style.setProperty(this.balancedPositionVar, item.nextValue);
				}
			}
		});
	}
}


export default IndexesSlideAnimator;
